/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


  $('.ProductForm__AddToCart').prop('disabled', true);
  $('.ProductForm__AddToCart span').text("Select Size");


  $('.SizeSwatchList li').on('click',function(e){
    $('.ProductForm__AddToCart span').text("Add to cart");
    $('.SizeSwatch').css({"border-color": "#eee", "color": "#909090"});
    $('.SizeSwatch__Radio:checked + .SizeSwatch').css({"border-color": "#1c1b1b", "color": "#1c1b1b"});
  	$('.ProductForm__AddToCart').prop('disabled', false);  
  });


//   	e.preventDefault();
//     $(this).toggleClass('active').closest('.product-option').siblings().find('.cls_selectbtnwrap').removeClass('active');
//     $(this).next('.dropdown_cls_list').slideToggle().closest('.product-option').siblings().find('.dropdown_cls_list').slideUp();
//     $('.wc_pro_option').removeClass('redbox');

// $(".add-to-cart").prop('disabled', true);
// $(".add-to-cart span").text("Select Size");

$(document).ready(function(){
  function updateCheckoutButton() {
    if ($('.cart-term-condition input[type="checkbox"]').prop("checked")) {
      $('.Cart__Checkout').removeClass('disabled');
    } else {
      $('.Cart__Checkout').addClass('disabled');
    }
  }

  $(document).on('click', '.cart-term-condition input[type="checkbox"]', updateCheckoutButton);

  $(window).on("load", updateCheckoutButton);
  $(document).ajaxComplete(function() {
    updateCheckoutButton();
  });
});

// $(document).ready(function(){
//   $('.cart-term-condition input[type="checkbox"]').click(function(){
//     if($(this).prop("checked") == true){
//       $('.Cart__Checkout').removeClass('disabled');
//     }else if($(this).prop("checked") == false){
//       $('.Cart__Checkout').addClass('disabled');
//     }
//   });
// });
// $(window).on("load",function(){
//   if($('.cart-term-condition input[type="checkbox"]').prop("checked") == true){
//     $('.Cart__Checkout').removeClass('disabled');
//   }else if($(this).prop("checked") == false){
//     $('.Cart__Checkout').addClass('disabled');
//   }
// });